module.exports = __webpack_public_path__ + "img/boundary-sel-logo.d78323b8.svg";